export const updateState = (prevState, newValues) => {
	const newValuesMap = new Map(newValues.map((item) => [item._id, item]));

	return prevState.map((item) => {
		if (newValuesMap.has(item._id)) {
			return newValuesMap.get(item._id);
		}
		return item;
	});
};
